module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-switch-wrapper"]
  }, [(_vm.loading) ? _c('dof-spinner', {
    staticClass: ["dof-switch-loading"],
    attrs: {
      "type": _vm.loadingSrc
    }
  }) : _vm._e(), _c('div', {
    ref: "switch",
    class: [_vm.type === 'white' ? 'switch-white' : 'switch', _vm.checked && _vm.switchActiveClass, ("switch-" + _vm.type)],
    style: Object.assign({}, _vm.mrSwitchStyle, _vm.customStyle),
    attrs: {
      "accessible": true,
      "ariaLabel": _vm.blindHelptext
    },
    on: {
      "click": _vm.changeHandler
    }
  }, [_c('div', {
    ref: "switchDot",
    class: [_vm.type === 'white' ? 'switch-white-dot' : 'switch-dot'],
    style: _vm.dotStyle,
    attrs: {
      "accessible": false,
      "ariaHidden": true
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-a1eea166!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-switch/index.vue
// module id = 644
// module chunks = 0 1